import AxiosService from "@/services/AxiosService";
import { jobService }  from "@/services/address";

const CONFIG_ADMIN_ENDPOINT = "/api/v1/admin";
const JOBS_ENDPOINT = `${CONFIG_ADMIN_ENDPOINT}/jobs`;


export default class ConfigurationService {

  constructor() {
    this.service = new AxiosService();
    this.jobService = jobService;
  }

  createJob(name) {
    let payload = {
      'job': name
    }
    return this.service.post(JOBS_ENDPOINT, payload,null);
  }

  listJobs() {
    return this.jobService.resolveJobs();
  }
}